import { render } from "./VideoGallery.vue?vue&type=template&id=8ca3486e&scoped=true"
import script from "./VideoGallery.vue?vue&type=script&lang=js"
export * from "./VideoGallery.vue?vue&type=script&lang=js"

import "./VideoGallery.vue?vue&type=style&index=0&id=8ca3486e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ca3486e"]])

export default __exports__